import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareAlignDownIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 18 18' {...props}>
    <g>
      <path
        d='M4 11v3H1v-3h3zm1-1H0v5h5v-5zM10 1v3H7V1h3zm1-1H6v5h5V0zM16 4v3h-3V4h3zm1-1h-5v5h5V3zM17 14h-1v1h1v-1zm-3 0h-1v1h1v-1zm-3 0h-1v1h1v-1zm-3 0H7v1h1v-1zM9 6H8v5H7l1.5 2 1.5-2H9V6zM15 9h-1v2h-1l1.5 2 1.5-2h-1V9z'
        fill='currentColor'
        className='svgicon__hover-hide'
      />
      <path
        d='M4 11v3H1v-3h3zm1-1H0v5h5v-5zM10 11v3H7v-3h3zm1-1H6v5h5v-5zM16 11v3h-3v-3h3zm1-1h-5v5h5v-5z'
        fill='currentColor'
        className='svgicon__hover-show'
      />
    </g>
  </SvgWrapper>
);

export const AlignDownIcon = memo(BareAlignDownIcon);
